window.jQuery(function ()
{
  var $ = window.jQuery;
   
  // CONDITIONAL LOGGING
  var logging = false;
  var conditional_log = function (msg){if (logging) console.log(msg);};
  
 
  


  
  
  
  
  // PRODUCT TEXT
  var $cms = $('#vitamin-cms');
  var keyPoints = [];
  $cms.find('.prod-decription li').each(function ()
  {
    keyPoints.push($.trim($(this).text()));
  });
  $cms.find('ul').remove();
  if (keyPoints.length)
  {
    $('#vitamin-middle>div>.points').show();
    
    for (var i=0; i<keyPoints.length; i++)
    {
      $('#vitamin-middle>div>.points>.bullets').append('<div><div class="tick"></div><div class="text">' + keyPoints[i] + '</div></div>');
    }
  }
  var description = $.trim($cms.find('.prod-decription').text());
  $('#vitamin-middle>div>.description>.text').text(description);
  if (description.length) $('#vitamin-middle>div>.description').show(); 
  
  
  
  
  // UPDATE TABS on VARIANT CHANGE
  var updateTabs = function (newVariantID)
  {
    conditional_log('show tabs for ' + newVariantID);
    var $variants = $('#vitamin-tabs>[variant-id="' +  newVariantID +'"]');
    conditional_log('tabs for ' + newVariantID + ' found = ' + ($variants.length/2));
    $('#vitamin-tabs>[variant-id]').removeClass('selected');
    $variants.each(function ()
    {
      $(this).addClass('selected');
      $(this).find('>.tabs>div:eq(0)').click();
    });
  };
  
  // UPDATE "ADD-TO-CART-SUPP-ITEMS" BASED on VARIANT CHANGE
  var updateSupps = function (variantID)
  {
    $('#vitamin-supps').hide().find('>[variant-id]').remove();
    var $supps = $('#vitamin-tabs>.desktop[variant-id="' + variantID + '"]>.content>[type="supp"]>a');
    
    if ($supps.length)
    {
      $('#vitamin-supps').show();
      
      var suppPopInfo = $('#vitamin-supp-pop-info').text();
      $supps.each(function ()
      {
        var html = '<div variant-id="' + $(this).attr('variant-id') + '">'
                 + '   <div class="check"><div></div></div>'
                 + '   <div class="content">' + $(this).find('.name').text() + ' (+ ' + $(this).find('.price').html() + ') <div class="qmark"></div></div>'
                 + '   <div class="pop hidden">' + suppPopInfo + '</div>'
                 + '</div>';

        $(html).appendTo($('#vitamin-supps'));

        $('#vitamin-supps>div:last .qmark').click(function ()
        {
          var top = $(this).parent().offset().top - $(window).scrollTop() - 70; 
          var left = $(this).parent().offset().left - $(window).scrollLeft();

          $(this).parent().next().css({
            top: top,
            left: left
          }).toggleClass('hidden');
        }).mouseenter(function () {
          $(this).addClass('hovered');
        }).mouseleave(function () {
          $(this).removeClass('hovered');
        });

        $('#vitamin-supps>div:last .check').click(function ()
        {
          $(this).parent().toggleClass('selected');
        });
        
        $('#vitamin-supps>div:last .pop').click(function ()
        {
          $(this).addClass('hidden');
        });
      });
    }
  };
  
  $(window).on('scroll resize', function ()
  {
    $('#vitamin-supps .pop').addClass('hidden');
  });
  
  $(document).click(function (){
    if (!$('#vitamin-supps>div .qmark.hovered').length) $('#vitamin-supps>div .pop').addClass('hidden');
  });
  
  
  
  
  
  
  // GET CURRENT VARIANT ID
  var oldVariantID = $('#product-select').val();
  var startCheckingForNewVariantID;
  var getCurrentVariantID = function (interval, cb)
  {
    clearInterval(startCheckingForNewVariantID);
    conditional_log('oldVariantID is ' + oldVariantID);
    var newVariantID = $('#product-select').val();
    if (newVariantID !== oldVariantID)
    {
      conditional_log('oldVariantID changed to ' + newVariantID + ' - will update tabs');
      clearInterval(startCheckingForNewVariantID);
      oldVariantID = newVariantID;
      cb(newVariantID);
    }
    else
    {
      conditional_log('oldVariantID still ' + oldVariantID + ' - will check again');
      startCheckingForNewVariantID = setInterval(function ()
      {
        getCurrentVariantID(interval*2, cb);
      }, interval);
    }
  };
  

  
  
  
  
  
  // TRACK VARIANT CHANGE
  var trackVariantChange = function (interval)
  {
    var $selectors = $('#product-variants select').not('.vitamin-tracked').not('.hidden');
    
    $selectors.addClass('vitamin-tracked').change(function ()
    {
      getCurrentVariantID(100, function (newVariantID)
      {
        updateTabs(newVariantID);
        updateSupps(newVariantID);
      });
    });
        
    // TRACK DYNAMICALLY ADDED VARIANTS
    setTimeout(function ()
    {
      trackVariantChange(interval*2);
    }, interval);
  };
  
  
  
  
  
  
  
  
  $('#vitamin-tabs>.desktop>.tabs>div:eq(0)').click();
   
  // SWITCH DESKTOP / MOBILE TABS
  $(window).resize(function ()
  {
    if ($(window).width() <= 780) $('#vitamin-tabs').removeClass('desktop').addClass('mobi');
    else $('#vitamin-tabs').removeClass('mobi').addClass('desktop');      
  }).resize();
  
  // ON DESKTOP TABS CLICK
  $('#vitamin-tabs>div>.tabs>div').click(function ()
  {
    if($(this).hasClass('selected')) return;
    var type = $(this).attr('type');
    $(this).addClass('selected').siblings().removeClass('selected');
    $(this).parent().next().find('>[type="' + type + '"]').show().siblings().hide();
  });
  
  // OPEN/CLOSE MOBILE TABS
  $('#vitamin-tabs>.mobi>.tab').click(function ()
  {
    $(this).toggleClass('open').siblings().removeClass('open');
    if ($(this).hasClass('open')) $(this).next().addClass('open');
  });
  
  
  
  
  
  
  //SCROLL TO PRODUCT SPECS ON CLICK
  if ($('#vitamin-tabs [variant-id]').length)
  {
    $('#vitamin-see-full').show().click(function()
    {
      $('html,body').animate({
        scrollTop: $('#vitamin-middle').offset().top - 200
      });
    });
  }
  
  
  
  
  
  
  // BUY NOW OVERRIDE
  var addToCart = function (arr, q, cb)
  {
    jQuery.ajax(
    {
      url: '/cart/add.js',
      type: 'POST',
      data:
      {
        quantity: q,
        id: arr[arr.length-1]
      },
      complete: function(response)
      {
        if (response.status && (response.status === 200)) arr.pop();
        if (!arr.length) cb();
        else
        {
          conditional_log('failed to add to cart - will try again');
          setTimeout(function ()
          {
            addToCart(arr, q, cb);
          }, 100);
        }
      }
    });
  };
  
  
  
  
  
  $('#vitamin-buy-now').click(function ()
  {
    var $this = $(this);
    
    $this.text('adding to cart..');
    
    var vIDs = [Number($('#product-select').val())];
    var q = Number($('#quantity').val());
    
    $('#vitamin-supps>.selected').each(function ()
    {
      vIDs.push(Number($(this).attr('variant-id')));
    });
    
    addToCart(vIDs, q, function ()
    {
      window.vitaminUpdateCartSummaries(function ()
      {
        $this.text('Buy now');
        if (!$('body').hasClass('show-cart-summary')) $('body').addClass('show-cart-summary');
      });
    });
  }); 
  
  
  
  
  
  
  // ON DOM READY SHOW CORRECT TABS fOR DEFAULT VARIANT/PRODUCT
  trackVariantChange(100);
  var defaultVariantID = $('#product-select').val();
  updateTabs(defaultVariantID);
  updateSupps(defaultVariantID);
  getCurrentVariantID(100, function (newVariantID)
  {
     updateTabs(newVariantID);
     updateSupps(newVariantID);
  });
  
  window.vitaminUpdateMiniCart();
  
});